import type { StackProps } from '@mui/material';
import Stack from '@mui/material/Stack';
import React from 'react';

export const Queries: React.FC<StackProps> = (props) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="end"
      {...props}
    />
  );
};